<template>
	<div>
		<div class="list_top_box">
			<h3>Best Selling Item {{ headers.class }}</h3>
			<p class="mgb_5">
				<span>Period Type: </span>
				<label class="mgr_10"><input type="radio" v-model="computedPeriod" value="LastWeek" /> LastWeek</label>
				<label class="mgr_10"><input type="radio" v-model="computedPeriod" value="LastMonth" /> LastMonth</label>
				<label class="mgr_10"><input type="radio" v-model="computedPeriod" value="Custom" />Custom</label>

				<span>
					<CustomDatePicker :disabled="period !== 'Custom'" v-model="from_date" /> ~
					<CustomDatePicker :disabled="period !== 'Custom'" v-model="to_date" />
				</span>
			</p>

			<p>
				<span>Based on: </span>
				<select class="tbl_select sm_int mgr_15" v-model="sort_key">
					<option value="quantity">Quantity</option>
					<option value="amount">Amount</option>
				</select>

				<a href="javascript:;" class="search_bt" @click="search(0)">Search</a>
			</p>
		</div>
		<table class="list_tbl mgb_30" border="0" style="table-layout: fixed">
			<thead>
				<tr>
					<th style="width: 5%;">Rank</th>
					<th style="width: 15%;">{{ headers.class }} Code</th>
					<th style="width: 35%;">{{ headers.class }} Name</th>
					<template v-if="search_sort_key === 'quantity'">
						<th style="width: 85px;">Amount($)</th>
						<th>Quantity</th>
					</template>
					<template v-else>
						<th style="width: 65px;">Quantity</th>
						<th>Amount($)</th>
					</template>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in bestItemList" :key="index">
					<td class="al_right">{{ item.ranking }}</td>
					<td class="al_center">{{ item.code }}</td>
					<td class="truncate" :title="item.name">{{ item.name }}</td>

					<template v-if="search_sort_key === 'quantity'">
						<td class="al_right">{{ item.amount | commaSeparated }}</td>
						<td>
							<p class="fl_l al_right" style="width: 65px;">
								<span>{{ item.quantity | commaSeparated }}</span>
							</p>
							<div class="fl_r" style="height: 20px; width: calc(100% - 80px); position: relative;">
								<UnitGraph :num="item.quantity" :max="max * 1.1" :min="min" style="height: 100%; width: 100%;" />
							</div>
						</td>
					</template>

					<template v-else>
						<td class="al_right">{{ item.quantity | commaSeparated }}</td>
						<td>
							<p class="fl_l al_right" style="width: 85px;">
								<span>{{ item.amount | commaSeparated }}</span>
							</p>
							<div class="fl_r" style="height: 20px; width: calc(100% - 100px); position: relative;">
								<UnitGraph :num="item.amount" :max="max * 1.2" :min="min" style="height: 100%; width: 100%;" />
							</div>
						</td>
					</template>
				</tr>
			</tbody>
		</table>

		<div class="bottom_bt_box">
			<span class="col_6">Search Period: {{ search_from_date }} ~ {{ search_to_date }}<br />Search Based on: {{ search_sort_key.toUpperCase() }}</span>
			<!-- <ul>
				<li>
					<a href="javascript: void(0);" class="gray_bt" @click="search(list_size * -1)">▲</a>
				</li>
				<li>
					<a href="javascript: void(0);" class="gray_bt" @click="search(list_size)">▼</a>
				</li>
			</ul> -->
		</div>
	</div>
</template>

<script>
import { apiGetBestItemList } from '@/api/statistics/statistics';
import { toText } from '@/utils/date';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import UnitGraph from '@/views/statistics/bestItem/UnitGraph';

export default {
	data: () => ({
		sort_key: null,
		period: null,
		from_date: null,
		to_date: null,
		start_index: 0,

		bestItemList: [],

		search_from_date: null,
		search_to_date: null,
		search_sort_key: null,

		max: 0,
		min: 0,
	}),
	components: {
		CustomDatePicker,
		UnitGraph,
	},
	props: {
		list_size: {
			type: Number,
			default: 10,
		},
	},
	computed: {
		computedPeriod: {
			get: function() {
				return this.period;
			},
			set: function(newValue) {
				this.period = newValue;
				this.changeFromNToDate();
			},
		},
		headers: function() {
			return { class: this.$session.get('headerClass') };
		},
	},
	methods: {
		changeFromNToDate() {
			if (this.period === 'Custom') return;

			let today = new Date();
			let from_date = null;
			let to_date = null;

			if (this.period === 'LastWeek') {
				to_date = new Date(today.getFullYear(), today.getMonth(), today.getDate() - (today.getDay() + 1));
				from_date = new Date(to_date.getFullYear(), to_date.getMonth(), to_date.getDate() - 6);
			} else if (this.period === 'LastMonth') {
				to_date = new Date(today.getFullYear(), today.getMonth(), 0);
				from_date = new Date(today.getFullYear(), today.getMonth() - 1, 1);
			}

			this.from_date = toText(from_date, '-');
			this.to_date = toText(to_date, '-');
		},

		async search(param) {
			if (param === 0) {
				this.start_index = 0;
			} else {
				let start_index = this.start_index + param;
				if (start_index > -1) this.start_index = start_index;
				else return;
			}

			await this.getBestItemList(param === 0);
		},
		async getBestItemList(changePeriodAndSort) {
			if (changePeriodAndSort) {
				this.search_from_date = this.from_date;
				this.search_to_date = this.to_date;
				this.search_sort_key = this.sort_key;
			}

			let { data } = await apiGetBestItemList(this.search_from_date, this.search_to_date, this.search_sort_key, this.start_index, this.list_size);

			if (!data) return this.$toast.error('error');
			else if (data.length < 1) this.$toast.error('No items.');

			this.max = 0;
			this.min = 0;
			this.bestItemList = data;

			this.bestItemList.forEach(el => {
				let num = this.sort_key === 'quantity' ? el.quantity : el.amount;
				if (num > this.max) this.max = num;
				if (num < this.min) this.min = num;
			});
		},
		async init() {
			this.sort_key = 'quantity';
			this.computedPeriod = 'LastWeek';

			await this.search(0);
		},
	},
	created() {
		this.init();
	},
};
</script>

<style></style>
